import { useNavigate } from "react-router-dom";
import { PortalSidebar, type SidebarNavSection } from "@/shared/layout/PortalSidebar";
import { SidebarProfileCard } from "@/shared/layout/SidebarProfileCard";
import { usePhysicianAuthStore } from "@/stores/physicianAuthStore";
import { getInitials } from "./getInitials";

const navSections: SidebarNavSection[] = [
  {
    title: "Overview",
    items: [
      // Also covers an item opened from My Items (/physician/my-items/:id).
      { path: "/physician/my-items", label: "My Items", icon: "lucide:briefcase-medical" },
      {
        path: "/physician",
        label: "Review Queue",
        icon: "lucide:clipboard-list",
        // An item opened from here (/physician/review/:id) keeps it highlighted; My Items doesn't.
        isActive: (pathname) => pathname === "/physician" || pathname.startsWith("/physician/review/"),
      },
    ],
  },
];

interface PhysicianSidebarProps {
  name: string;
}

export function PhysicianSidebar({ name }: PhysicianSidebarProps) {
  const signOut = usePhysicianAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  const handleSignOut = () => {
    void signOut();
    navigate("/physician/login", { replace: true });
  };

  return (
    <PortalSidebar
      logoTitle="MedSyncIQ"
      logoSubtitle="Physician Portal"
      profileSlot={
        <SidebarProfileCard
          avatarInitials={getInitials(name)}
          name={name}
          detailsLine="Physician Account"
          showChevron={false}
        />
      }
      navSections={navSections}
      onSignOut={handleSignOut}
    />
  );
}
